import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function NotFound() {
  return (
    <div className="page-notfound">
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />
      <div className="container content-page" style={{ textAlign: 'center', paddingTop: '4rem' }}>
        <h1 style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>404</h1>
        <p style={{ fontSize: '1.2rem', color: 'var(--text-muted)', marginBottom: '2rem' }}>The page you are looking for does not exist or has been moved.</p>
        <Link to="/" className="btn btn-primary btn-lg">Go Home</Link>
      </div>
    </div>
  );
}

export default NotFound;
